import React from "react";

/**
 * MiniBoard — a tiny top-down silhouette of a board's tile footprint.
 * Renders the exact shape of the daily/weekly board that was played
 * (e.g. "spartan_shield", "gym_temple") as small emerald-tinted blocks.
 *
 * Props:
 *   footprint: array of [x, y] coordinate pairs (from the backend)
 *   size: max pixel width of the rendered minimap (default 76)
 */
export default function MiniBoard({ footprint = [], size = 76 }) {
  if (!footprint || footprint.length === 0) return null;

  const xs = footprint.map((p) => p[0]);
  const ys = footprint.map((p) => p[1]);
  const minX = Math.min(...xs);
  const maxX = Math.max(...xs);
  const minY = Math.min(...ys);
  const maxY = Math.max(...ys);

  const tileW = 1.9;
  const spanX = maxX - minX + tileW;
  const spanY = maxY - minY + tileW;
  const px = size;
  const pyRaw = (spanY / spanX) * size;
  const py = Math.max(28, Math.min(pyRaw, size));

  return (
    <svg
      data-testid="mini-board"
      width={px}
      height={py}
      viewBox={`0 0 ${spanX} ${spanY}`}
      role="img"
      aria-label="board shape"
      style={{ filter: "drop-shadow(0 3px 6px rgba(0,0,0,0.35))" }}
    >
      <defs>
        <linearGradient id="miniTileFill" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#EBC77A" />
          <stop offset="100%" stopColor="#C99A3B" />
        </linearGradient>
      </defs>
      {footprint.map(([x, y], i) => (
        <rect
          key={i}
          x={x - minX}
          y={y - minY}
          width={tileW}
          height={tileW}
          rx={0.35}
          fill="url(#miniTileFill)"
          stroke="#8A6A22"
          strokeWidth={0.12}
          opacity={0.95}
        />
      ))}
    </svg>
  );
}
